/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface RecommendsItem
 */
export interface RecommendsItem {
    /**
     *
     * @type {string}
     * @memberof RecommendsItem
     */
    title: string;
    /**
     *
     * @type {string}
     * @memberof RecommendsItem
     */
    id: string;
    /**
     *
     * @type {string}
     * @memberof RecommendsItem
     */
    displayName: string;
    /**
     *
     * @type {string}
     * @memberof RecommendsItem
     */
    description: string;
    /**
     *
     * @type {string}
     * @memberof RecommendsItem
     */
    actionTarget: string;
    /**
     *
     * @type {string}
     * @memberof RecommendsItem
     */
    actionText: string;
    /**
     *
     * @type {string}
     * @memberof RecommendsItem
     */
    visibleFrom: string;
    /**
     *
     * @type {string}
     * @memberof RecommendsItem
     */
    visibleUntil: string;
    /**
     *
     * @type {Array<string>}
     * @memberof RecommendsItem
     */
    targetAudience: string[];
    /**
     *
     * @type {Array<string>}
     * @memberof RecommendsItem
     */
    targetCountries: string[];
    /**
     *
     * @type {Array<string>}
     * @memberof RecommendsItem
     */
    targetPositions: string[];
}

export function RecommendsItemFromJSON(json: any): RecommendsItem {
    return RecommendsItemFromJSONTyped(json, false);
}

export function RecommendsItemFromJSONTyped(json: any, _: boolean): RecommendsItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'title': json['title'],
        'id': json['id'],
        'displayName': json['display_name'],
        'description': json['description'],
        'actionTarget': json['action_target'],
        'actionText': json['action_text'],
        'visibleFrom': json['visible_from'],
        'visibleUntil': json['visible_until'],
        'targetAudience': json['target_audience'],
        'targetCountries': json['target_countries'],
        'targetPositions': json['target_positions'],
    };
}

export function RecommendsItemToJSON(value?: RecommendsItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'title': value.title,
        'id': value.id,
        'display_name': value.displayName,
        'description': value.description,
        'action_target': value.actionTarget,
        'action_text': value.actionText,
        'visible_from': value.visibleFrom,
        'visible_until': value.visibleUntil,
        'target_audience': value.targetAudience,
        'target_countries': value.targetCountries,
        'target_positions': value.targetPositions,
    };
}
